
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetStaticProps, NextPage } from "next";
import Meta from "~/components/common/Meta/Meta";
import { Vendor } from "~/components/landings/constants";
import CleoLanding from "~/components/landings/vendors/CleoLanding/CleoLanding";
import { VENDOR_TO_ADVERTISEMENT_MAP } from "~/components/landings/vendorToAdvertisementMap";
type Props = {
    advertisementId: string;
};
const CleoLandingPage: NextPage = ({ advertisementId }: Props) => (<>
    <Meta pageKey="landing-cleo"/>
    <CleoLanding advertisementId={advertisementId}/>
  </>);
export default CleoLandingPage;
const getStaticProps: GetStaticProps = async () => {
    const advertisementId = VENDOR_TO_ADVERTISEMENT_MAP[Vendor.Cleo];
    if (!advertisementId) {
        return {
            notFound: true
        };
    }
    return {
        props: {
            advertisementId
        }
    };
};

    async function __Next_Translate__getStaticProps__18c1550c11b__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/landing/Cleo',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__18c1550c11b__ as getStaticProps }
  